import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/hooks/useAuth";
import { UploadQueueProvider } from "@/upload/UploadQueueContext";
import PullToRefresh from "@/components/feature/PullToRefresh";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <UploadQueueProvider>
            <PullToRefresh />
            <AppRoutes />
          </UploadQueueProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
